import { buildBase } from "./constants";

const BASE = buildBase("reports");

export const REPORTS_ROUTES = (() => {
  /*
    ======================================================
    ADD ALL BASIC ROUTES HERE
    ======================================================
  */
  const basicRoutes = {
    ROOT: BASE,
  };

  /*
    ======================================================
    ADD ALL ROUTES THAT REQUIRE NESTING BELOW
    ======================================================
  */
  const PAYOUTS_ROOT = `${BASE}/payouts`;
  const PAYOUTS = {
    ROOT: PAYOUTS_ROOT,
    detail: (transactionId: string | number) =>
      `${PAYOUTS_ROOT}/${transactionId}`,
    settings: () => `${PAYOUTS_ROOT}/settings`,
  };

  return {
    ...basicRoutes,
    PAYOUTS,
  };
})();
